













import BaseInputComponent from "component-models/src/baseInputModel";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
const rounded = "rounded";
const rectangle = "rectangle";
@Component({
  name: "new-custom-switcher" //,
  //mixins: [BaseInputComponent]
})
export default class NewCustomSwitcherComponent extends BaseInputComponent {
  @Prop({
    default: false,
    type: [Boolean, String, Number, Number, Date, Object, Array]
  })
  yesValue?: any | any[] | Boolean | String | Number | string | number | Date;
  @Prop({
    default: true,
    type: [Boolean, String, Number, Number, Date, Object, Array]
  })
  noValue?: any | any[] | Boolean | String | Number | string | number | Date;
  @Prop({
    default: rounded,
    validator: (x: string) => {
      return x == rounded || x == rectangle;
    }
  })
  type: string;
  hasFocus = false;
  toggle() {
    if (this.disabled) {
      return;
    }
    this.innerValue =
      this.innerValue == this.yesValue ? this.noValue : this.yesValue;
      this.$emit('toggle', this.innerValue);
  }
  mounted() {
    document.addEventListener("keydown", this.onKeyDown.bind(this));
  }
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeyDown.bind(this));
  }
  onGetFocus() {
    this.hasFocus = true;
  }
  onBlur() {
    this.hasFocus = false;
  }
  onKeyDown(ev: KeyboardEvent) {
    var key = ev.key.toLowerCase();
    if (this.hasFocus && key == "enter") {
      return this.toggle();
    }
  }
}
